import React from 'react';
import {Button} from '@pepsico-ds/ui/Atoms';
import Icon from '@/components/atoms/Icon';
import ActionMenu from '@/components/organisms/PeacockDataTable/ActionMenu';

const ToolbarActionsRight = ({actions, actionMenuConfig}) => {
  const hasActions = actions && actions.length > 0;
  const hasActionMenu = !!actionMenuConfig;

  if (!hasActions && !hasActionMenu) return null;

  return (
    <div
      className='peacock-toolbar-right-actions'
      data-testid='toolbar-actions-right'>
      {hasActions &&
        actions.map((action, idx) =>
          action.iconOnly ? (
            <button
              key={idx}
              className='peacock-icon-btn'
              onClick={action.onClick}
              disabled={action.isDisabled}
              title={action.text}
              data-testid={`toolbar-icon-btn-${idx}`}>
              <Icon icon={action.iconName} size='small' />
            </button>
          ) : (
            <Button
              key={idx}
              text={action.text}
              variant={action.variant || 'secondary'}
              size='medium'
              disabled={action.isDisabled}
              onClick={action.onClick}
              iconLeading={action.iconLeading}
            />
          )
        )}
      {hasActionMenu && <ActionMenu {...actionMenuConfig} />}
    </div>
  );
};

export default ToolbarActionsRight;
